'use client';

import { useDecisions } from '../../../hooks';
import { GtmLegacy } from './GTM.legacy';

export const GtmScript = () => {
    const isOneTrust = useDecisions('onetrust');

    if (isOneTrust) return null;

    return <GtmLegacy />;
};
